/**
 * Done. / ChiroCPD — useUnsavedChanges Hook
 *
 * Registers a beforeunload event to warn users when leaving a page
 * with unsaved form changes.
 *
 * Usage: useUnsavedChanges(isDirty)
 * Pass `true` when a form has unsaved data; `false` (or omit) otherwise.
 */

import { useEffect } from 'react';

export function useUnsavedChanges(dirty: boolean): void {
  useEffect(() => {
    if (!dirty) return;

    function handleBeforeUnload(event: BeforeUnloadEvent): string {
      event.preventDefault();
      // Modern browsers show a generic message; returning a string is legacy support
      return 'You have unsaved changes. Leave anyway?';
    }

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [dirty]);
}
